var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "b-container",
    { staticClass: "atmo-nested-section" },
    [
      _c(
        "b-row",
        [
          _c("b-col", [
            _c("h3", { staticClass: "grey-color font-weight-bold mb-3" }, [
              _vm._v("Создание дополнительного соглашения о расторжении"),
            ]),
          ]),
          _c(
            "b-col",
            { attrs: { md: "auto" } },
            [
              _c(
                "b-button",
                {
                  staticClass: "font-weight-bold mt-1 mr-1",
                  attrs: {
                    href: "https://info.zakupschik.ru/201--rastorzhenie-dogovora-s-postavshikom",
                    variant: "custom-danger",
                    target: "_blank",
                  },
                },
                [_vm._v("Инструкция по расторжению контракта")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "b-overlay",
        {
          attrs: {
            show: _vm.isLoading,
            opacity: "0.6",
            rounded: "",
            "spinner-variant": "primary",
          },
        },
        [
          _c("form-row-single-select", {
            attrs: {
              label: "Основание для расторжения контракта",
              v: _vm.$v.terminationType,
              options: _vm.$globalDictionaries.fl44ContractTerminationTypes,
              labelField: "title",
            },
            model: {
              value: _vm.terminationType,
              callback: function ($$v) {
                _vm.terminationType = $$v
              },
              expression: "terminationType",
            },
          }),
        ],
        1
      ),
      _vm.terminationType
        ? _c(_vm.createComponent, {
            tag: "component",
            attrs: {
              purchase: _vm.purchase,
              terminationType: _vm.terminationType,
            },
            on: { cancel: _vm.onCancel, done: _vm.onSend },
          })
        : _vm._e(),
      !_vm.terminationType
        ? _c(
            "b-button",
            {
              staticClass: "text-uppercase mt-1",
              attrs: { variant: "custom-outline-secondary" },
              on: { click: _vm.onCancel },
            },
            [_vm._v("Отмена")]
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }